import React from 'react';
import './EunoiaPage.css';

const EunoiaPage: React.FC = () => {
  return (
    <div className="eunoia-container">
      <header className="eunoia-header">
        <h1>Eunoia</h1>
        <p className="tagline">Your Personal Journaling Companion</p>
      </header>
      
      <main className="eunoia-content">
        <section className="intro">
          <h2>Welcome to Eunoia</h2>
          <p>
            Eunoia is a beautiful, distraction-free journaling app designed to help you capture your thoughts, 
            reflect on your experiences, and cultivate mindfulness in your daily life.
          </p>
        </section>

        <section className="features">
          <h3>Features</h3>
          <ul>
            <li>🌙 Clean, minimalist interface</li>
            <li>🔒 End-to-end encryption for your privacy</li>
            <li>📅 Daily prompts and reflections</li>
            <li>📊 Mood and habit tracking</li>
            <li>📱 Available across all your devices</li>
          </ul>
        </section>

        <section className="coming-soon">
          <h3>Coming Soon!</h3>
          <p>
            We're currently working hard to bring you the best journaling experience possible. 
            Sign up below to be notified when we launch.
          </p>
          <div className="cta">
            <button className="notify-button">Notify Me on Launch</button>
          </div>
        </section>
      </main>

      <footer className="eunoia-footer">
        <p>© {new Date().getFullYear()} Eunoia Journal. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default EunoiaPage;
